import { render, staticRenderFns } from "./spu.vue?vue&type=template&id=16154c6a&"
import script from "./spu.vue?vue&type=script&lang=js&"
export * from "./spu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports